export const TASK_TYPE_LIST_REQUEST = 'TASK_TYPE_LIST_REQUEST'
export const TASK_TYPE_LIST_SUCCESS = 'TASK_TYPE_LIST_SUCCESS'
export const TASK_TYPE_LIST_FAIL = 'TASK_TYPE_LIST_FAIL'

